import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './index.css';
import { Pagination } from 'swiper/modules';
import CommentSection from '../../components/CommentsSection/index';
import RatingSummary from '../../components/StarRating';
import { FaHeart, FaRegHeart } from 'react-icons/fa'; // Icons for favorite

const AppDetail = () => {
    const { id } = useParams();
    const [app, setApp] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFavorite, setIsFavorite] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;

    const telegramUserId = localStorage.getItem('telegram_user_id');

    useEffect(() => {
        const fetchApp = async () => {
            try {
                const response = await fetch(`${apiUrl}apps/list/${id}/?user_id=${telegramUserId}`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                console.log(data);
                
                setApp(data);
                setIsFavorite(data.is_favorite);
            } catch (error) {
                console.error('Error fetching app:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };
    
        fetchApp();
    }, [id, apiUrl, telegramUserId]);
    

    const toggleFavorite = async () => {
        if (!telegramUserId) {
            console.error('User ID not found in localStorage');
            return;
        }
    
        try {
            const response = await fetch(`${apiUrl}apps/favorites/`, {
                method: isFavorite ? 'DELETE' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: telegramUserId,
                    app_id: id,
                }),
            });
    
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
    
            // Update the isFavorite state based on the action performed
            if (isFavorite) {
                setIsFavorite(false); // Successfully removed from favorites
            } else {
                const result = await response.json();
                setIsFavorite(result.is_favorite); // Successfully added to favorites
            }
        } catch (error) {
            console.error('Error updating favorite:', error);
        }
    };
    

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!app) {
        return <div>App not found.</div>;
    }

    const iconUrl = `${apiUrl}${app.icon}`;

    return (
        <div className="app-detail">
            <div className="app-detail-header">
                <img src={iconUrl} alt={app.name} className="app-detail-icon" style={{ maxWidth: '100%', height: 'auto' }} />

                <div className="app-detail-info">
                    <h1>{app.name}</h1>
                    <div className="developer">{app.developer}</div>
                    <div className="app-detail-ad-info">Есть реклама · Есть платный контент</div>
                </div>

                <div className="favorite-icon" onClick={toggleFavorite} style={{ cursor: 'pointer' }}>
                    {isFavorite ? <FaHeart color="red" /> : <FaRegHeart />}
                </div>
            </div>

            <div className="app-detail-rating-info">
                <div>
                    <div className="app-detail-rating">{app.rating} ★</div>
                </div>
                <div>
                    <div>3+ years</div>
                </div>
            </div>

            <div className='downloadLink'>
                <a href={app.download_link} className="app-detail-install-btn">Играть</a>
            </div>

            <div className="app-detail-media-section">
                {app.screenshots && app.screenshots.length > 0 ? (                    
                    <Swiper
                        slidesPerView={'auto'}
                        centeredSlides={true}
                        spaceBetween={30}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination]}
                        className="mySwiper"
                    >
                        {app.screenshots.map((screenshot) => (
                            <SwiperSlide key={screenshot.id}>
                                <img 
                                    src={`${apiUrl}${screenshot.image}`} 
                                    alt="App Screenshot" 
                                    className="app-detail-media-image" 
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div>No screenshots available</div>
                )}
            </div>

            <div className="app-detail-description-section">
                <h2>Описание</h2>
                <div dangerouslySetInnerHTML={{ __html: app.description }} />
            </div>

            <RatingSummary appId={app.id} />

            <div className="app-detail-comments-section">
                <h2>Комментарии</h2>
                <CommentSection appId={id} comments={app.comments} />
            </div>
        </div>
    );
};

export default AppDetail;
